import React, { useContext } from 'react';
import { ComparatorContext } from '@kizi/comparator-core';
import { WithFormProps } from '../HOCs';
import { CheckboxProps } from '@kizi/shared-components';
import { Checkbox } from './inputs/withFormProps';
import Mustache from 'mustache';

const renderFormattedLabel = (label, keyWithAnchor) => {
  return Mustache.render(label, keyWithAnchor);
};

export const CheckboxWrapper: React.FC<WithFormProps<CheckboxProps>> = ({
  label,
  ...props
}) => {
  const { getStateFromLocalStorage, name } = useContext(ComparatorContext);
  const persistedState = getStateFromLocalStorage();
  let formatedLabel = label;

  if (name === 'car' && props.propMap !== undefined) {
    const overview = persistedState?.context?.initialSteps[3];

    const selectedProductField = overview?.fields.find((f) => {
      return f.name === 'selectedProduct';
    })?.value;

    const selectedProduct = JSON.parse(selectedProductField as string);
    const mapKeys = Object.keys(props.propMap);

    const keyWithAnchor = {};
    mapKeys.forEach((mapKey) => {
      const providerAttributes = selectedProduct.provider.attributes;
      let attributeValue;
      if (mapKey in providerAttributes) {
        attributeValue = providerAttributes[mapKey];
        keyWithAnchor[mapKey] = attributeValue;
      } else {
        if (mapKey === 'general_terms') {
          keyWithAnchor['general_terms'] =
            providerAttributes['insurance_policy'];
        } else if (mapKey === 'insurance_policy') {
          keyWithAnchor['insurance_policy'] =
            providerAttributes['general_terms'];
        } else {
          attributeValue = '';
          keyWithAnchor[mapKey] = attributeValue;
        }
      }
    });
    formatedLabel = renderFormattedLabel(label, keyWithAnchor);
  }

  return <Checkbox {...props} label={formatedLabel} _label={undefined} />;
};
